import { render, staticRenderFns } from "./CoachSkeletonLoader.vue?vue&type=template&id=571089c8"
import script from "./CoachSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./CoachSkeletonLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports